import styled from '@emotion/styled';
import React from 'react';
import { Text } from '../..';
import { ThemeProps } from '../../../types';

interface VoucherInfoProps {
    header: string;
    details: string;
    className: string;
}
const VoucherInfo = ({ header, details, className }: VoucherInfoProps) => {
    return (
        <section className={className}>
            <div>
                <Text color='white' weight='bold'>{header}</Text>
                <Text color='white' >{details}</Text>
            </div>
        </section>
    )
}

const StyledVoucherInfo = styled((props: any) => <VoucherInfo {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
        backgroundColor: theme.colors.accent,
        borderColor: theme.colors.accent,
        borderStyle: 'solid',
        borderRadius: theme.radii.basket,
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 24,
        padding: '8px 16px',
        width: '100%',
        div: {
            justifyContent: 'space-between',
        },
    })}
`;

export default StyledVoucherInfo;